import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { baseSchema, getFields } from "../../../signup.fielddefs.ts";
import { FormCreator } from "@/components/shared/form-creator";
import { toast } from "sonner";
import {useSignup} from "@/app/auth/signup/signup.hooks.ts";
import {useNavigate} from "react-router";

export function PlainSignupForm({ prefilledEmail }: { prefilledEmail: string }) {
    const { saving, error, submit } = useSignup("plain");
    const navigate = useNavigate();

  const form = useForm({
    resolver: zodResolver(baseSchema),
    defaultValues: {
      email: prefilledEmail,
      organizationType: undefined,
    },
  });

  const fields = getFields({
    showOrgType: true,
    showOrgName: true,
  });

  const onSubmit = async (vals: any) => {
    try {
      const { needsVerification } = await submit(vals);

      toast.success(needsVerification ? "Account created. Confirm your email to finish signing up." : "Account created!");

      if (!needsVerification) navigate("/");
    } catch (e: any) {
      toast.error(e.message ?? "Signup failed");
    }
  };

  return (
    <>
      {error && <p className="text-sm text-destructive mb-2">{error}</p>}
      <FormCreator
        form={form}
        formDefinition={fields}
        buttonText={saving ? "Creating…" : "Create account"}
        onSubmit={onSubmit}
      />
    </>
  );
}
